import React from 'react';
import { Outlet, useSearchParams, useLocation } from 'react-router-dom';
import { Box } from '@mui/joy';
import ClientSidebar from './components/ClientSideBar'; // adjust if needed

const ClientLayout = () => {
  const [params] = useSearchParams();
  const location = useLocation();
  const embedded = params.get("embedded") === "true";
  const isMapPage = location.pathname.includes('/map');
  if (embedded) return <Outlet />;

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        width: '100vw',
        overflowX: 'hidden',
        overflowY: isMapPage ? 'hidden' : 'auto',
        background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.9) 100%)',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 80%, rgba(0, 168, 132, 0.03) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(0, 126, 51, 0.03) 0%, transparent 50%)',
          zIndex: -1,
          pointerEvents: 'none',
        }
      }}
    >
      <ClientSidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: isMapPage ? 'hidden' : 'auto',
          position: 'relative',
          minHeight: '100vh',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default ClientLayout;
